/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  GET_FLIGHT_STATUS_REQUEST,
  GET_FLIGHT_STATUS_SUCCESS,
  GET_FLIGHT_STATUS_ERROR,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}

export function handleFormDataEnableTime(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function getFlightStatusRequest(flightNumber, flightDate, flightObjectName, currentStepName) {
  return {
    type: GET_FLIGHT_STATUS_REQUEST,
    flightNumber,
    flightDate,
    flightObjectName,
    currentStepName,
  };
}

export function getFlightStatusSuccess(flightData) {
  return {
    type: GET_FLIGHT_STATUS_SUCCESS,
    payload: flightData,
  };
}

export function getFlightStatusError(error) {
  return {
    type: GET_FLIGHT_STATUS_ERROR,
    error,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/actions.js